const commtypes = [
  { id: 'Email', name: 'Email' },
  { id: 'Cellphone', name: 'Cellphone' },
  { id: 'Telephone', name: 'Telephone' },
  { id: 'WhatsApp', name: 'WhatsApp' },
  { id: 'Twitter', name: 'Twitter' },
  { id: 'Facebook', name: 'Facebook' },
];
export default commtypes;
